import { Dossier } from "./dossier";
import { Projet } from "./projet";
import { ProprieteAffichee } from "./proprieteAffichee";
import { Site } from "./site";
import { WorkflowEtapeInstance } from "./workflowEtapeInstance";

export enum DirectoryType {
  EXPERTAB = 0,
  GEODATA = 1,
  USERFILES = 2,
  VIBRATIONS = 3,
  VIBRATIONSTEMP = 4
}

export class Fichier {
  fichierId: number;
  nom: string;
  dossierId: number;
  workflowEtapeInstanceId: number;
  siteId: number;
  projetId: number;
  dossier: Dossier;
  workflowEtapeInstance: WorkflowEtapeInstance;
  site: Site;
  projet: Projet;
  ext: string;
  taille: number;
  dateCreation: Date;
  isSelected:boolean;
  storedInS3: boolean;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    return tab;
  }
}
